import enums from '../enums/RdsLife.enums';
export default class Dish {
  constructor({ id, name, categoria, ingredienti, likes }, inject) {
    this.id = id;
    this.name = name;
    this.categoria = categoria;
    this._ingredienti = ingredienti;
    this.likes = [];
    this.tipologia = enums.modelTypes.DISH;
    if (!!inject && !!inject.users) {
      // let userLike = inject.users.map(u => u.likes.products).filter(l => l.indexOf(this.id) != -1);
      let usersLike = inject.users.filter(u => u.likes.dishes.indexOf(this.id) !== -1).map(u => u.id);
      this.likes = usersLike;
    } else {
      console.log('no users');
    }
  }
  set ingredienti(ingredienti) {
    this._ingredienti = ingredienti;
  }
  get ingredienti() {
    this._ingredienti.filter((el, idx, arr) => {
      return arr.map((i) => i.name).indexOf() === idx;
    });
  }
}
